import type { StorageGateway, StorageLike } from "@/interface/DTO_Interfaces"

export const createMemoryStorageAdapter = (): StorageLike => {
        const memory = new Map<string, string>()

        return {
                getItem: (key) => (memory.has(key) ? memory.get(key)! : null),
                setItem: (key, value) => memory.set(key, value),
                removeItem: (key) => memory.delete(key)
        }
}

export const createJsonStorageGateway = (adapter: StorageLike): StorageGateway => ({
        getItem: <T>(key: string) => {
                const rawValue = adapter.getItem(key)
                if (!rawValue) return null

                try {
                        return JSON.parse(rawValue) as T
                } catch {
                        return null
                }
        },
        setItem: <T>(key: string, value: T) => adapter.setItem(key, JSON.stringify(value)),
        removeItem: (key: string) => adapter.removeItem(key)
})

const resolveBrowserStorage = (): StorageLike => {
        if (typeof window !== "undefined" && window.localStorage) return window.localStorage
        return createMemoryStorageAdapter()
}

export const browserStorageGateway = createJsonStorageGateway(resolveBrowserStorage())
